/* eslint-disable */

import services from 'services';

export default {
  settings: async ({ commit }) => {
    const res = await services.SettingsService.getSettings();
    commit('SET_SETTINGS', res);
  },
};
